module.exports = __webpack_public_path__ + "img/accounts.5b312472.jpg";